import App from './App.svelte';
const app = new App({
    target: document.body,
    props: {
        name: 'world',
        siteLinks: {
            features: '/features',
            pricing: '/pricing',
            AppStore: 'https://apps.apple.com/app/ordrk/id1555944793',
            PlayStore: 'https://play.google.com/store/apps/details?id=net.alephdigital.ordrk&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
        },
    }
});
export default app;
